/* eslint-disable @typescript-eslint/no-restricted-imports */
import { TechRefStoreState } from '@squareup/dex-tech-shell';
import { useSelector } from 'react-redux';

// Shell View State
const selectSpecVersionInView = (state: TechRefStoreState) => {
  return state.techRefShellViewState.specVersionInView;
};

// Entities
const selectGraphEntitiesInView = (state: TechRefStoreState) => {
  return state.graphEntitiesInView;
};

const selectApiInView = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).api;
};

const selectObjectInView = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).object;
};

const selectEndpointInView = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).endpoint;
};

const selectEnumInView = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).enum;
};

const selectWebhookInView = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).webhook;
};

// React Selector Hooks
// Spec related
const useSelectSpecVersionInView = () => useSelector(selectSpecVersionInView);
const useGraphEntitiesInView = () => useSelector(selectGraphEntitiesInView);

export {
  useSelectSpecVersionInView,
  useGraphEntitiesInView,
  selectSpecVersionInView,
  selectApiInView,
  selectObjectInView,
  selectEndpointInView,
  selectEnumInView,
  selectGraphEntitiesInView,
  selectWebhookInView,
};
